var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotel_User_part_UI",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_Results_modify_01",
    transform: "translate(-566 -1938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Footers/v1",
    transform: "translate(0 1629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(165 271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Links",
    transform: "translate(285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master",
    transform: "translate(116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 50.83,
    height: 38.05,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#9DADBC",
    strokeOpacity: 0.36,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard-logo",
    fillRule: "nonzero",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#231F20",
    transform: "matrix(1 0 0 -1 1.698 27.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M31.067.647V.581h.062c.013 0 .025.003.033.008a.03.03 0 0 1 .013.025c0 .011-.005.02-.013.025a.059.059 0 0 1-.033.008h-.062Zm.062.047a.114.114 0 0 0 .074-.022.07.07 0 0 0 .026-.058.067.067 0 0 0-.02-.05.101.101 0 0 0-.06-.026l.082-.093h-.064l-.075.093h-.025V.445h-.053v.249h.115Zm-.016-.335c.03 0 .056.005.081.016a.212.212 0 0 1 .11.112.213.213 0 0 1-.044.23.207.207 0 0 1-.147.06.21.21 0 0 1-.15-.06.203.203 0 0 1-.043-.067.202.202 0 0 1-.017-.082c0-.029.006-.056.017-.081a.196.196 0 0 1 .11-.112.205.205 0 0 1 .083-.016m0 .478a.269.269 0 0 0 .194-.08.263.263 0 0 0 .058-.293.278.278 0 0 0-.145-.143.273.273 0 0 0-.382.247.263.263 0 0 0 .167.247c.034.015.07.022.108.022m-25.217.96c0 .475.312.865.82.865.486 0 .815-.373.815-.865S7.202.93 6.716.93c-.508 0-.82.39-.82.866m2.189 0v1.351h-.588V2.82c-.187.243-.47.396-.854.396-.758 0-1.352-.594-1.352-1.42 0-.825.594-1.419 1.352-1.419.385 0 .667.153.854.396V.445h.588v1.352Zm19.86 0c0 .475.31.865.82.865.486 0 .814-.373.814-.865S29.25.93 28.764.93c-.508 0-.82.39-.82.866m2.19 0v2.437h-.59V2.82c-.186.243-.468.396-.853.396-.758 0-1.352-.594-1.352-1.42 0-.825.594-1.419 1.352-1.419.385 0 .667.153.854.396V.445h.588v1.352ZM15.38 2.69c.378 0 .622-.238.684-.656H14.66c.063.39.3.656.719.656m.011.526c-.792 0-1.346-.577-1.346-1.42 0-.859.577-1.419 1.386-1.419.407 0 .78.102 1.108.379l-.288.436a1.292 1.292 0 0 0-.787-.283c-.378 0-.723.175-.808.662h2.007c.006.073.012.147.012.226-.006.842-.527 1.42-1.284 1.42m7.096-1.42c0 .475.312.865.82.865.487 0 .815-.373.815-.865S23.794.93 23.307.93c-.508 0-.82.39-.82.866m2.189 0v1.351h-.588V2.82c-.187.243-.47.396-.854.396-.758 0-1.352-.594-1.352-1.42 0-.825.594-1.419 1.352-1.419.385 0 .667.153.854.396V.445h.588v1.352Zm-5.508 0c0-.82.571-1.42 1.442-1.42.408 0 .679.09.973.323l-.283.475a1.188 1.188 0 0 0-.707-.244c-.47.006-.814.345-.814.866 0 .52.345.86.814.865.255 0 .487-.085.707-.243l.283.475c-.294.231-.565.322-.973.322-.87 0-1.442-.6-1.442-1.42m7.578 1.42a.798.798 0 0 1-.713-.396v.328h-.583V.445h.589V1.96c0 .448.192.696.576.696.12 0 .244-.017.368-.068l.181.554c-.13.051-.3.074-.418.074M10.99 2.933c-.283.187-.672.283-1.102.283-.685 0-1.125-.328-1.125-.865 0-.441.328-.713.932-.798l.278-.04c.322-.044.474-.13.474-.282 0-.209-.215-.328-.616-.328-.407 0-.7.13-.899.283L8.656.728c.322-.237.73-.35 1.17-.35.78 0 1.233.367 1.233.882 0 .475-.356.723-.944.808l-.277.04c-.254.034-.458.084-.458.265 0 .198.192.317.514.317.345 0 .68-.13.843-.232l.254.475Zm7.583.283a.796.796 0 0 1-.712-.396v.328h-.582V.445h.587V1.96c0 .448.193.696.577.696.12 0 .244-.017.368-.068l.181.554c-.13.051-.3.074-.419.074m-5.015-.068h-.961v.82h-.594v-.82h-.549v-.537h.549V1.378c0-.627.243-1 .938-1 .255 0 .549.078.735.208l-.17.504a1.088 1.088 0 0 0-.52-.153c-.293 0-.39.181-.39.453v1.22h.962v.538ZM4.77.445v1.697c0 .639-.407 1.068-1.063 1.074-.345.006-.701-.102-.95-.48-.187.299-.48.48-.893.48-.289 0-.571-.085-.792-.401v.333H.485V.445h.593v1.499c0 .469.26.718.662.718.39 0 .588-.254.588-.713V.445h.594v1.499c0 .469.271.718.662.718.401 0 .593-.254.593-.713V.445h.594Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#F79410",
    transform: "matrix(1 0 0 -1 31.833 17.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.294 0v.395h-.102l-.12-.271-.118.27H.85V0h.074v.298l.11-.257h.077l.111.257V0h.072ZM.641 0v.327h.132v.067H.437V.327h.132V0H.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#FF5F00",
    d: "M21.425 19.44h-8.907V3.432h8.907z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#EB001B",
    transform: "matrix(1 0 0 -1 .144 21.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.945 10.356c0 3.247 1.52 6.14 3.888 8.003a10.136 10.136 0 0 1-6.292 2.177C4.92 20.536.362 15.978.362 10.356.362 4.733 4.92.176 10.542.176c2.374 0 4.56.813 6.29 2.176a10.163 10.163 0 0 0-3.887 8.004"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#F79E1B",
    transform: "matrix(1 0 0 -1 16.61 21.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.828 10.356c0-5.623-4.557-10.18-10.179-10.18-2.375 0-4.56.813-6.292 2.176a10.162 10.162 0 0 1 3.889 8.004c0 3.247-1.52 6.14-3.889 8.003a10.139 10.139 0 0 0 6.292 2.177c5.622 0 10.179-4.558 10.179-10.18"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.19e4eea13718af19be0e6232199aaf0b.svg";
export { ForwardRef as ReactComponent };